export default __webpack_public_path__ + "static/media/message_icon.2f04a9eb.svg";